<template>
  <div class="print-step1">
    <div class="checkin-wrap">
      <checkin-form @callback="checkIn"></checkin-form>
    </div>
    <div class="rule-wrap">
      <rule></rule>
    </div>
  </div>
</template>
<style lang="less" scoped>
.print-step1 {
  .checkin-wrap {
    width: 388px;
    margin: 0 auto;
    padding-top: 30px;
  }
  .rule-wrap {
    padding-top: 50px;
  }
}
@media only screen and (max-width: 768px) {
  .print-step1 {
    .checkin-wrap {
      width: 96%;
      padding-top: 15px;
    }
  }
  .rule-wrap {
    width: 96%;
    margin: 0 auto;
    padding-top: 30px;
  }
}
</style>
<script>
import CheckinForm from '@/components/checkin/checkinForm'
import Rule from '@/components/checkin/rule'
export default {
  components: {
    CheckinForm,
    Rule
  },
  methods: {
    checkIn (data) {
      this.$emit('callback', 2, data)
    }
  }
}
</script>
